<template>
    <div v-if="listing" style="margin:20px;">
      <div class="row">
        <div class="col-sm-12">
          <div style="float:right">
            <button class="btn btn-primary btn-blue" @click="$modal.hideAll()">
              <i class="fa fa-close"></i>
            </button>
          </div>
          <h3>{{ listing.city }}, {{ listing.state }}</h3>

        </div>
      </div>
      <div class="row">
        <div
          class="col-sm-6 justify-content-md-center"
          style="margin: 0 auto; padding-top: 10px"
          v-if="listing.photo"
        >
          <a :href="`https://${listing.website}`" target="_blank">
            <img
              v-if="listing.photo"
              :src="`https://api.everythingcheeranddance.com/public/photo?key=${listing.photo}`"
              width="100%"
              height="auto"
              style="border-radius: 10px; object-fit: cover"
            />
          </a>
        </div>
      </div>
      <div class="row" v-if="listing">
        <div
          style="margin-top: 20px; text-align: left"
          v-for="(field, index) in listing.fields"
          class="col-sm-6"
          :key="index + '_details'"
        >
          <h4>{{ field.name }}</h4>
          <a
            :href="'mailto:' + utils.findFieldValue(listing, field.name)"
            v-if="field.type == 'Email'"
            >{{ utils.findFieldValue(listing, field.name) }}</a
          >
          <a
            target="_blank"
            :href="utils.findFieldValue(listing, field.name)"
            v-else-if="field.type == 'Website'"
            >{{ utils.findFieldValue(listing, field.name) }}</a
          >
          <p v-else>{{ utils.findFieldValue(listing, field.name) }}</p>
        </div>
      </div>

      <div class="row" v-if="listing">
        <div style="margin-top: 20px; text-align: left" class="col-sm-6">
          <h4>City</h4>
          <p>{{ listing.city }}</p>
        </div>
        <div style="margin-top: 20px; text-align: left" class="col-sm-6">
          <h4>State</h4>
          <p>{{ listing.state }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12" style="text-align:right">
          <button class="btn btn-primary btn-orange" @click="$modal.hideAll()">
            Dismiss
          </button>
        </div>
      </div>
    </div>

</template>

<script>
import Utils from "@/Utils/Utils";
import BasicModal from './BasicModal.vue';
import VModal from "vue-js-modal";
export default {
  name: "FeedModal",
  mounted() {
  },
  components: {
    BasicModal
  },
  data() {
    return {
      utils: Utils,
    };
  },
  props: {
    listing: {
      default: {},
    }
  },
  computed: {},
  methods: {
    favorite(listing) {
      this.$emit("favorite", listing);
    },
    unfavorite(listing) {
      this.$emit("unfavorite", listing);
    }
  },
  watch: {
    listing(newVal) {

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 768px) {
  .hidden-sm {
    display: none;
  }
}

.white {
  color: white;
}

.search {
  background: #f2f2f2;
  border-radius: 10px;
  margin: 0px;
  padding: 20px;
  margin-bottom: 20px;
}

.small {
  font-size: 90%;
}

.medium {
  font-size: 130%;
}

.large {
  font-size: 170%;
}

.pane {
  width: 100%;
  min-height: 100px;
  background: #f2f2f2;
  border-radius: 10px;
  margin-top: 20px;
  padding: 10px;
}

.row {
  margin-top: 20px;
}

.btn-blue {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ListingModal.vue